import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BodySmall, Box, Modal, ModalHeader, ModalFooter, Checkbox } from '@parspec/pixel';

import { useGetTwoFactorPreferencesQuery, useTwoFactorChangePreferenceMutation } from '../Authentication/queries';

interface SetupMFAModalProps {
    open: boolean;
    onClose: () => void;
}

const SetupMFAModal: FC<SetupMFAModalProps> = ({ open, onClose }) => {
    const navigate = useNavigate();
    const [notShowAgain, setNotShowAgain] = useState(false);

    const { data: mfaInfo } = useGetTwoFactorPreferencesQuery();

    const { mutate: updatePreferences } = useTwoFactorChangePreferenceMutation();

    const handleNotShowAgain = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNotShowAgain(e.target.checked);
    };

    const handleHidePopup = () => {
        if (notShowAgain && mfaInfo?.data) {
            updatePreferences({ ...mfaInfo.data, is_setup_dialog_box_enabled: false });
        }
    };

    const handleClose = () => {
        handleHidePopup();
        onClose();
    };

    const handleSubmit = () => {
        handleHidePopup();
        navigate('/v2/settings/my-profile?tab=security');
        handleClose();
    };

    return (
        <Modal
            open={open}
            header={<ModalHeader title="Let’s Secure Your Account" onClose={handleClose} />}
            footer={
                <ModalFooter
                    onAccept={handleSubmit}
                    helperText={
                        <Box>
                            <Checkbox label="Don’t ask again" checked={notShowAgain} onChange={handleNotShowAgain} />
                        </Box>
                    }
                    onReject={handleClose}
                    continueButtonLabel="Set up MFA"
                    cancelButtonLabel="Skip"
                />
            }
        >
            <Box width={406} my={2}>
                <Box>
                    <BodySmall limit={false} color='text.primary'>
                        We strongly recommend the use of Multi-Factor Authentication (MFA) or Single Sign-On (SSO) to enhance the security of your account. Getting setup will only take a few minutes!
                    </BodySmall>
                </Box>
            </Box>
        </Modal>
    );
};

export default SetupMFAModal;
